import { render } from "./FairTowers.vue?vue&type=template&id=0ca48434&scoped=true"
import script from "./FairTowers.vue?vue&type=script&lang=js"
export * from "./FairTowers.vue?vue&type=script&lang=js"

import "./FairTowers.vue?vue&type=style&index=0&id=0ca48434&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca48434"]])

export default __exports__